import {
  RealTimeAction,
  AllRoomTypeSymbol,
  AllRoomStatusSymbol,
  OrderOption,
  ViewOption,
} from '@/redux/actions/roomState/constant';
import { ChannelItem } from '@/redux/reducers/reservation/base';

const initialState = {
  fullRoomRate: null, // 满房率
  checkInNum: null, // 入住人数
  isTodoFold: false, // 待办折叠状态
  filterSearchText: null, // 搜索文字
  filterFastType: null, // 快捷筛选
  filterRoomStatus: [], // 筛选房态
  filterRoomType: [], // 筛选房型
  filterChannel: [], // 筛选渠道
  filterTypeId: AllRoomTypeSymbol, // 筛选房型
  filterTypeStatus: AllRoomStatusSymbol, // 筛选房态
  listOrderType: OrderOption.floorNo, // 排序类型
  listViewType: ViewOption.roomState, // 视图类型
  channelFilterList: [], // 渠道列表
  roomTypeList: [], // 房型列表
  fastFilterList: [], // 快捷列表
  roomStateList: [], // 房间原数据列表
  roomStatusCountMap: {}, // 房态数量信息
  roomViewList: [], // 视图列表
  businessDate: Date.now(), // 营业日
  channelList: [], // 渠道列表
  cardEnabled: false,
};

type ReducerState = typeof initialState;

type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;

const reducerMap = {
  [RealTimeAction.initUserConfig]: <ActionHandler<Partial<ReducerState>>>((state, { payload }) => {
    return {
      ...state,
      ...payload,
    };
  }),
  [RealTimeAction.setRoomStateData]: <ActionHandler<Partial<ReducerState>>>((
    state,
    { payload },
  ) => {
    return {
      ...state,
      ...payload,
    };
  }),
  [RealTimeAction.setFilterSearchText]: <ActionHandler<string>>((state, { payload }) => {
    return {
      ...state,
      filterSearchText: payload,
    };
  }),
  [RealTimeAction.setFilterFastType]: <ActionHandler<string>>((state, { payload }) => {
    return {
      ...state,
      filterFastType: payload,
    };
  }),
  [RealTimeAction.setFilterRoomStatus]: <ActionHandler<Array<string>>>((state, { payload }) => {
    return {
      ...state,
      filterRoomStatus: payload,
    };
  }),
  [RealTimeAction.setFilterRoomType]: <ActionHandler<Array<number>>>((state, { payload }) => {
    return {
      ...state,
      filterRoomType: payload,
    };
  }),
  [RealTimeAction.setFilterChannel]: <ActionHandler<Array<string>>>((state, { payload }) => {
    return {
      ...state,
      filterChannel: payload,
    };
  }),
  [RealTimeAction.setOrderType]: <ActionHandler<OrderOption>>((state, { payload }) => {
    return {
      ...state,
      listOrderType: payload,
    };
  }),
  [RealTimeAction.setViewType]: <ActionHandler<ViewOption>>((state, { payload }) => {
    return {
      ...state,
      listViewType: payload,
    };
  }),
  [RealTimeAction.setTodoFoldStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return {
      ...state,
      isTodoFold: payload,
    };
  }),
  [RealTimeAction.setBusinessDate]: <ActionHandler<number>>((state, { payload }) => {
    return {
      ...state,
      businessDate: payload,
    };
  }),
  [RealTimeAction.setChannelList]: <ActionHandler<ChannelItem[]>>((state, { payload }) => {
    return {
      ...state,
      channelList: payload,
    };
  }),
  [RealTimeAction.setCardStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, cardEnabled: payload };
  }),
};

export default (state = initialState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(state, action);
  }
  return state;
};
